import React from 'react';

import { ITargetingPreset } from '~/src/dash/apiV2/targeting/targetingPresets';
import { Text } from '~/src/dash/publicaUI';
import {
  ETargetingGDPR,
  TargetingGDPRConsentOptions,
  TargetingGDPROptions,
} from '~/src/dash/utils/options';
import { convertSingleNumericIDForSummaryZeroDefault } from '~/src/dash/views/tools/TargetingPresets/TargetingPresetFormView/config';

interface IGDPRSummaryProps {
  preset: ITargetingPreset;
}

export const GDPRSummary = ({ preset }: IGDPRSummaryProps) => {
  const value = convertSingleNumericIDForSummaryZeroDefault(
    preset.TargetingGDPR,
    TargetingGDPROptions,
  );

  let consentValue = '';
  const hasConsentValue = preset.TargetingGDPR === ETargetingGDPR.GDPR1;
  if (hasConsentValue) {
    consentValue =
      TargetingGDPRConsentOptions.find((option) => option.id === preset.TargetingGDPRConsent)
        ?.label || 'N/A';
  }

  return (
    <div>
      {value && (
        <Text small>{`${value}${hasConsentValue ? `, Consent: ${consentValue}` : ''}`}</Text>
      )}
    </div>
  );
};
